export enum TreeEntityType {
  OFFLINE = 'offline',
  CHANNEL_GROUP = 'ChannelGroup',
  CHANNEL = 'Channel',
  INSTANCE = 'Instance',
  USE_CASE_ROOT = 'UseCaseRoot',
  MASTER = 'Master',
}
